import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TAccessLevel } from '../types/types';

const initialState:
    {
        AccessLevels: TAccessLevel[]

    } = {
    AccessLevels: []
}

const AccessLevel = createSlice({
    name: 'accessLevel',
    initialState,
    reducers: {
        addAccessLevels: (state, action: PayloadAction<TAccessLevel[]>) => {
            state.AccessLevels = action.payload
        },
    },
});

export const { addAccessLevels } = AccessLevel.actions;

export default AccessLevel.reducer;
